import { serverNow } from '@/lib/server-time'

export type SLAState = 'ok' | 'warning' | 'breached' | 'none'

// getSLAState collapses (deadline, warning_at, breached_flag) into a single
// state for the badge. Uses server time (not Date.now) so a skewed browser
// clock doesn't fake "quá hạn".
//
// Precedence (top wins):
//   1. no deadline           → 'none'
//   2. sla_breached=true     → 'breached'  (cron already stamped it)
//   3. now >= deadline       → 'breached'  (client-side early detection)
//   4. warning_at ≤ now      → 'warning'   (amber "sắp trễ")
//   5. otherwise             → 'ok'
export function getSLAState(
    deadlineAt: string | undefined,
    breached: boolean,
    warningAt?: string,
): SLAState {
    if (!deadlineAt) return 'none'
    if (breached) return 'breached'
    const now = serverNow()
    const deadlineMs = new Date(deadlineAt).getTime()
    if (deadlineMs <= now) return 'breached'
    if (warningAt) {
        const warningMs = new Date(warningAt).getTime()
        if (warningMs <= now) return 'warning'
    }
    return 'ok'
}

export function formatCountdown(deadlineAt: string): string {
    const diff = new Date(deadlineAt).getTime() - serverNow()
    if (diff <= 0) return ''
    const h = Math.floor(diff / 3_600_000)
    const m = Math.floor((diff % 3_600_000) / 60_000)
    return h > 0 ? `${h}h ${m}m` : `${m}m`
}
